/* eslint-disable no-var */
export var MidExtOpenCoinBill = MidExtOpenCoinBill || {};

export var MidExtComm = MidExtComm || {};

export var HUYA = HUYA || {};

MidExtOpenCoinBill.ConfirmedInfo = function () {
  this.confirmStatus = 0;
  this.confirmTime = 0;
};

MidExtOpenCoinBill.ConfirmedInfo.prototype.readFrom = function (is) {
  this.confirmStatus = is.readInt32(0, false, this.confirmStatus);
  this.confirmTime = is.readInt64(1, false, this.confirmTime);
};

MidExtOpenCoinBill.ConfirmedInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.confirmStatus);
  os.writeInt64(1, this.confirmTime);
};

MidExtOpenCoinBill.ConfirmedInfo.prototype._clone = function () {
  return new MidExtOpenCoinBill.ConfirmedInfo();
};
MidExtOpenCoinBill.ConfirmedInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
MidExtOpenCoinBill.ConfirmedInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

MidExtOpenCoinBill.GetConfirmedStatusReq = function () {
  this.tId = new HUYA.UserId();
};

MidExtOpenCoinBill.GetConfirmedStatusReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
};

MidExtOpenCoinBill.GetConfirmedStatusReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
};

MidExtOpenCoinBill.GetConfirmedStatusReq.prototype._clone = function () {
  return new MidExtOpenCoinBill.GetConfirmedStatusReq();
};
MidExtOpenCoinBill.GetConfirmedStatusReq.prototype._write = function (
  os,
  tag,
  value
) {
  os.writeStruct(tag, value);
};
MidExtOpenCoinBill.GetConfirmedStatusReq.prototype._read = function (
  is,
  tag,
  def
) {
  return is.readStruct(tag, true, def);
};

HUYA.UserId = function () {
  this.lUid = 0;
  this.sGuid = "";
  this.sToken = "";
  this.sHuYaUA = "";
  this.sCookie = "";
  this.iTokenType = 0;
  this.sDeviceInfo = "";
};

HUYA.UserId.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sGuid = is.readString(1, false, this.sGuid);
  this.sToken = is.readString(2, false, this.sToken);
  this.sHuYaUA = is.readString(3, false, this.sHuYaUA);
  this.sCookie = is.readString(4, false, this.sCookie);
  this.iTokenType = is.readInt32(5, false, this.iTokenType);
  this.sDeviceInfo = is.readString(6, false, this.sDeviceInfo);
};

HUYA.UserId.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sGuid);
  os.writeString(2, this.sToken);
  os.writeString(3, this.sHuYaUA);
  os.writeString(4, this.sCookie);
  os.writeInt32(5, this.iTokenType);
  os.writeString(6, this.sDeviceInfo);
};

HUYA.UserId.prototype._clone = function () {
  return new HUYA.UserId();
};
HUYA.UserId.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserId.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

MidExtOpenCoinBill.GetConfirmedStatusResp = function () {
  this.response = new MidExtComm.ExtCommonResponse();
  this.confirmedInfo = new MidExtOpenCoinBill.ConfirmedInfo();
};

MidExtOpenCoinBill.GetConfirmedStatusResp.prototype.readFrom = function (is) {
  this.response = is.readStruct(0, false, this.response);
  this.confirmedInfo = is.readStruct(1, false, this.confirmedInfo);
};

MidExtOpenCoinBill.GetConfirmedStatusResp.prototype.writeTo = function (os) {
  os.writeStruct(0, this.response);
  os.writeStruct(1, this.confirmedInfo);
};

MidExtOpenCoinBill.GetConfirmedStatusResp.prototype._clone = function () {
  return new MidExtOpenCoinBill.GetConfirmedStatusResp();
};
MidExtOpenCoinBill.GetConfirmedStatusResp.prototype._write = function (
  os,
  tag,
  value
) {
  os.writeStruct(tag, value);
};
MidExtOpenCoinBill.GetConfirmedStatusResp.prototype._read = function (
  is,
  tag,
  def
) {
  return is.readStruct(tag, true, def);
};

MidExtComm.ExtCommonResponse = function () {
  this.res = 0;
  this.msg = "";
};

MidExtComm.ExtCommonResponse.prototype.readFrom = function (is) {
  this.res = is.readInt32(0, false, this.res);
  this.msg = is.readString(1, false, this.msg);
};

MidExtComm.ExtCommonResponse.prototype.writeTo = function (os) {
  os.writeInt32(0, this.res);
  os.writeString(1, this.msg);
};

MidExtComm.ExtCommonResponse.prototype._clone = function () {
  return new MidExtComm.ExtCommonResponse();
};
MidExtComm.ExtCommonResponse.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
MidExtComm.ExtCommonResponse.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolResp = function () {
  this.response = new MidExtComm.ExtCommonResponse();
};

MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolResp.prototype.readFrom =
  function (is) {
    this.response = is.readStruct(0, false, this.response);
  };

MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolResp.prototype.writeTo =
  function (os) {
    os.writeStruct(0, this.response);
  };

MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolResp.prototype._clone =
  function () {
    return new MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolResp();
  };
MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolResp.prototype._write =
  function (os, tag, value) {
    os.writeStruct(tag, value);
  };
MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolResp.prototype._read =
  function (is, tag, def) {
    return is.readStruct(tag, true, def);
  };

MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolReq = function () {
  this.tId = new HUYA.UserId();
  this.requset = new MidExtComm.ExtCommonRequest();
};

MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolReq.prototype.readFrom =
  function (is) {
    this.tId = is.readStruct(0, false, this.tId);
    this.requset = is.readStruct(1, false, this.requset);
  };

MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolReq.prototype.writeTo =
  function (os) {
    os.writeStruct(0, this.tId);
    os.writeStruct(1, this.requset);
  };

MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolReq.prototype._clone =
  function () {
    return new MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolReq();
  };
MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolReq.prototype._write =
  function (os, tag, value) {
    os.writeStruct(tag, value);
  };
MidExtOpenCoinBill.ConfirmOpenCoinCommissionProtocolReq.prototype._read =
  function (is, tag, def) {
    return is.readStruct(tag, true, def);
  };

MidExtComm.ExtCommonRequest = function () {
  this.componentTag = "";
  this.jwt = "";
  this.sHostId = "";
  this.extVersionTag = "";
};

MidExtComm.ExtCommonRequest.prototype.readFrom = function (is) {
  this.componentTag = is.readString(0, false, this.componentTag);
  this.jwt = is.readString(1, false, this.jwt);
  this.sHostId = is.readString(2, false, this.sHostId);
  this.extVersionTag = is.readString(3, false, this.extVersionTag);
};

MidExtComm.ExtCommonRequest.prototype.writeTo = function (os) {
  os.writeString(0, this.componentTag);
  os.writeString(1, this.jwt);
  os.writeString(2, this.sHostId);
  os.writeString(3, this.extVersionTag);
};

MidExtComm.ExtCommonRequest.prototype._clone = function () {
  return new MidExtComm.ExtCommonRequest();
};
MidExtComm.ExtCommonRequest.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
MidExtComm.ExtCommonRequest.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};
